import { render, staticRenderFns } from "./SpaceDetails.vue?vue&type=template&id=30e6be4a&scoped=true"
import script from "./SpaceDetails.vue?vue&type=script&lang=ts"
export * from "./SpaceDetails.vue?vue&type=script&lang=ts"
import style0 from "./SpaceDetails.vue?vue&type=style&index=0&id=30e6be4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e6be4a",
  null
  
)

export default component.exports